/*
  PRODUCT GRID CONTROLS (2026-09-15) - Sort, the Columns stepper, the Per page
  switch, the phone's Display panel and the description's "Read more", for
  sections/collection-template.liquid and the search results page
  (snippets/bc-search-results.liquid), which share one toolbar
  (snippets/bc-grid-toolbar.liquid) and one set of stored choices.

  The column count is already on <html> before the grid is parsed:
  snippets/bc-grid-prepaint.liquid sets data-bc-cols-desktop / data-bc-cols-phone
  from the URL (?cols=), then localStorage, then the defaults (4 and 2), and the
  stylesheet lays the grid out from those attributes. The same script defines
  window.bcCollSteppers, which writes each stepper's value and greys out a
  button at the end of its range, and window.bcGridSizes, which sizes the card
  photos to one column; this file calls both after every change.

    columns   [-] and [+] step 3-10 on desktop (3-6 on a tablet) and 1-4 on the
              phone; the grid re-flows at once with no reload, the choice is
              stored per device range and written to ?cols= with replaceState,
              and each image's fallback sizes follow for browsers without
              sizes="auto"
    per page  the options are real links (?view=25 / none / ?view=100 /
              ?view=200); a click
              stores the choice and keeps the first product on screen in view by
              mapping the page number to the new page size
    display   the phone's panel is a <details>; a tap outside it or Escape
              closes it
    read more the description is clamped to two lines by CSS; the toggle hides
              itself when the text fits, and expands / collapses it otherwise
*/
(function () {
  'use strict';

  /*
    ONE COPY PER PAGE (2026-10-17). This file is what opens a card's loupe
    (openCardGallery, below), so since the loupe shows on every screen the
    surfaces that render cards outside a collection grid load it too -
    Related Products on the product page, the New Products rail, the blog's
    product blocks. Its listeners are on the document, so a second copy
    would bind them twice; the first copy wins and re-runs itself on
    shopify:section:load, which is what a later row needs anyway.
  */
  if (window.BCCollectionControls) return;
  window.BCCollectionControls = true;

  var KEYS = {
    desktop: 'bc:collection:cols-desktop',
    phone: 'bc:collection:cols-phone',
    perPage: 'bc:collection:per-page'
  };
  var root = document.documentElement;
  var phoneQuery = window.matchMedia('(max-width: 749px)');
  var tabletQuery = window.matchMedia('(min-width: 750px) and (max-width: 1023px)');

  function store(key, value) {
    try {
      window.localStorage.setItem(key, String(value));
    } catch (error) {
      /* storage blocked: the choice lasts for this page only */
    }
  }

  function activeRange() {
    return phoneQuery.matches ? 'phone' : 'desktop';
  }

  function limits(range) {
    if (range === 'phone') return [1, 4];
    return [3, tabletQuery.matches ? 6 : 10];
  }

  function colsFor(range) {
    var lim = limits(range);
    var value = parseInt(root.getAttribute('data-bc-cols-' + range), 10) || (range === 'phone' ? 2 : 4);
    return Math.min(Math.max(value, lim[0]), lim[1]);
  }

  function setUrlParam(name, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(name, value);
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }

  function syncSteppers() {
    if (typeof window.bcCollSteppers === 'function') window.bcCollSteppers();
  }

  function updateSizes() {
    if (typeof window.bcGridSizes === 'function') {
      window.bcGridSizes();
      return;
    }
    var cols = colsFor(activeRange());
    var grids = document.querySelectorAll('[data-bc-coll-grid]');
    for (var g = 0; g < grids.length; g += 1) {
      var grid = grids[g];
      var gap = parseFloat(window.getComputedStyle(grid).columnGap) || 0;
      var slot = Math.ceil((grid.clientWidth - gap * (cols - 1)) / cols);
      if (!(slot > 0)) continue;
      var images = grid.querySelectorAll('img[data-bc-card-image]');
      for (var i = 0; i < images.length; i += 1) {
        images[i].sizes = 'auto, ' + slot + 'px';
      }
    }
  }

  function onStep(event) {
    var button = event.target.closest && event.target.closest('[data-bc-step-by]');
    if (!button || button.disabled) return;
    var stepper = button.closest('[data-bc-step]');
    if (!stepper) return;
    var range = stepper.getAttribute('data-bc-step');
    var lim = limits(range);
    var next = colsFor(range) + (parseInt(button.getAttribute('data-bc-step-by'), 10) || 0);
    next = Math.min(Math.max(next, lim[0]), lim[1]);
    root.setAttribute('data-bc-cols-' + range, next);
    store(KEYS[range], next);
    if (range === activeRange()) setUrlParam('cols', next);
    syncSteppers();
    updateSizes();
  }

  function onPerPageClick(event) {
    var link = event.target.closest && event.target.closest('a[data-bc-per-page]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var next = parseInt(link.getAttribute('data-bc-per-page'), 10);
    var group = link.closest('[data-bc-per-page-current]');
    var current = group ? parseInt(group.getAttribute('data-bc-per-page-current'), 10) : 50;
    if (!next) return;
    event.preventDefault();
    store(KEYS.perPage, next);
    if (next === current) return;
    var url = new URL(window.location.href);
    var page = parseInt(url.searchParams.get('page'), 10) || 1;
    var nextPage = Math.floor(((page - 1) * current) / next) + 1;
    if (next === 50) {
      url.searchParams.delete('view');
    } else {
      url.searchParams.set('view', next);
    }
    if (nextPage > 1) {
      url.searchParams.set('page', nextPage);
    } else {
      url.searchParams.delete('page');
    }
    window.location.assign(url.pathname + url.search + url.hash);
  }

  /*
    SORT BY (2026-10-30, the owner: "choosing a value in the SORT BY dropdown
    does nothing" on the search results).

    The only code that answered the select was theme.js's collectionSorting,
    which Slate creates for a [data-section-type="collection-template"]
    element and nothing else; the search results have none, and theme.js's
    page-wide binding sits behind {% if settings.collection_sort_enable %},
    a SECTION setting that the theme settings never have, so it compiles to
    nothing. On search the select took the new label over results in the old
    order, with no navigation at all.

    So the shared toolbar's select is answered here, on both page types: a
    change rebuilds the URL from the page's own (q, type, view, cols and any
    filter kept, sort_by set, page dropped back to 1) and loads it. The
    listener is on the document in the capture phase and stops the event, so
    on a collection theme.js's handler never runs as well and the page
    navigates once. Which values are offered is the server's list
    (collection.sort_options / search.sort_options), and /search lists only
    the three it honours - relevance and the two price orders.

    A page the browser brings back from its cache keeps the select as it was
    left - the new sort's label over the old sort's results - so on every
    pageshow the select is put back on the option the server marked selected.
    A Back that reloads the page instead would have the browser refill the
    select from its saved form state before pageshow; the select's
    autocomplete="off" (snippets/bc-grid-toolbar.liquid) stops that.
  */
  var sortPending = false;

  function onSortChange(event) {
    var select = event.target;
    if (!select || select.id !== 'SortBy' || !select.closest || !select.closest('.bc-coll-tools')) return;
    event.stopPropagation();
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    sortPending = true;
    window.location.assign(url.pathname + url.search + url.hash);
  }

  function onPageShow(event) {
    if (event.persisted) sortPending = false;
    if (sortPending) return;
    var selects = document.querySelectorAll('.bc-coll-tools select#SortBy');
    for (var s = 0; s < selects.length; s += 1) {
      var options = selects[s].options;
      for (var o = 0; o < options.length; o += 1) {
        if (options[o].defaultSelected) {
          if (selects[s].value !== options[o].value) selects[s].value = options[o].value;
          break;
        }
      }
    }
  }

  function closeDisplays(except) {
    var panels = document.querySelectorAll('details[data-bc-display][open]');
    for (var i = 0; i < panels.length; i += 1) {
      if (panels[i] !== except) panels[i].removeAttribute('open');
    }
  }

  /*
    THE CARD'S LOUPE (2026-09-15, the owner: "tapping it opens nothing").

    assets/longoni-lightbox.js binds its triggers by walking a ROOT - the
    homepage promo strip, [data-mcdermott-tiles], [data-case-tiles] or
    [data-bc-lightbox-root] - and attaching a listener to each button it finds
    inside one. A collection or search grid is none of those, so the buttons
    the cards render were never bound: the viewer was loaded and idle, and the
    tap fell through to nothing.

    Rather than teach the grid to look like a promo strip, the grid opens the
    viewer itself, through the handle that module publishes
    (window.BCLongoniLightbox.open). The listener is delegated from the
    document, so it holds for cards that arrive later - a column change, the
    next page, the search page's re-render - and it stops the event so the
    card's own link never takes the tap.

    The viewer's script is deferred, so a tap in the first moments of a page
    can land before it exists; the open is retried a few times rather than
    dropped.
  */
  function openCardGallery(id, trigger, attempt) {
    var viewer = window.BCLongoniLightbox;
    if (viewer && typeof viewer.open === 'function') {
      viewer.open(id, 0, trigger);
      return;
    }
    if ((attempt || 0) > 10) return;
    window.setTimeout(function () { openCardGallery(id, trigger, (attempt || 0) + 1); }, 150);
  }

  function onLoupeClick(event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest('[data-longoni-gallery-trigger]');
    if (!trigger || !trigger.closest('.bc-coll')) return;
    var id = trigger.getAttribute('data-longoni-gallery-trigger');
    if (!id) return;
    event.preventDefault();
    event.stopPropagation();
    openCardGallery(id, trigger, 0);
  }

  function onDocumentClick(event) {
    onLoupeClick(event);
    if (event.defaultPrevented) return;
    onStep(event);
    onPerPageClick(event);
    var inside = event.target.closest && event.target.closest('details[data-bc-display]');
    closeDisplays(inside);
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('details[data-bc-display][open]');
    if (!open) return;
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  }

  function initDescriptions() {
    var boxes = document.querySelectorAll('[data-bc-coll-desc]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.hasAttribute('data-bc-ready')) return;
      box.setAttribute('data-bc-ready', '');
      var text = box.querySelector('[data-bc-coll-desc-text]');
      var toggle = box.querySelector('[data-bc-coll-desc-toggle]');
      if (!text || !toggle) return;

      function measure() {
        if (box.classList.contains('is-expanded')) return;
        box.classList.toggle('is-short', text.scrollHeight <= text.clientHeight + 1);
      }

      toggle.addEventListener('click', function () {
        var open = !box.classList.contains('is-expanded');
        box.classList.toggle('is-expanded', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = toggle.getAttribute(open ? 'data-label-less' : 'data-label-more');
        if (!open) measure();
      });

      measure();
      var timer = 0;
      window.addEventListener('resize', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(measure, 120);
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    });
  }

  /*
    THE CARD'S PRESS STATE ON TOUCH (2026-09-15, the owner's mobile punch-list).

    The card used to take its highlight from :hover and :has(:focus-visible),
    and on a phone both outlive the tap: iOS keeps :hover on the last element
    touched, and the name's link keeps focus. Two faults followed. The frame
    only ever appeared when the TEXT was tapped, because the photo's link is
    aria-hidden with tabindex="-1" and takes no focus; and after the column
    count changed the frame stayed with that still-focused card, which had
    moved somewhere else in the grid - the "wrong card" the owner saw.

    So on touch the highlight is written here instead: .is-tapped goes on the
    card under the finger on pointerdown, wherever on the card it lands, and
    comes off the moment the finger lifts, the touch is cancelled, or the page
    scrolls. The stylesheet shows it at 1 and 2 columns only. clearTapped also
    runs on every column change, so no card can keep a frame across a re-flow.
  */
  var TAPPED = 'is-tapped';
  var tappedCard = null;

  function clearTapped() {
    if (tappedCard) {
      tappedCard.classList.remove(TAPPED);
      tappedCard = null;
    }
    var stale = document.querySelectorAll('.bc-ccard.' + TAPPED);
    for (var i = 0; i < stale.length; i += 1) stale[i].classList.remove(TAPPED);
  }

  function onPointerDown(event) {
    if (event.pointerType === 'mouse') return;
    if (!phoneQuery.matches) return;
    if (colsFor('phone') > 2) return;
    var card = event.target.closest && event.target.closest('.bc-ccard');
    if (!card) return;
    // A tap on a control is that control's, not the card's.
    if (event.target.closest('button, input, select, textarea, [role="button"]')) return;
    clearTapped();
    card.classList.add(TAPPED);
    tappedCard = card;
  }

  function onRangeChange() {
    closeDisplays(null);
    clearTapped();
    syncSteppers();
    updateSizes();
  }

  function init() {
    syncSteppers();
    updateSizes();
    initDescriptions();
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('change', onSortChange, true);
  window.addEventListener('pageshow', onPageShow);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('pointerdown', onPointerDown, { passive: true });
  document.addEventListener('pointerup', clearTapped, { passive: true });
  document.addEventListener('pointercancel', clearTapped, { passive: true });
  window.addEventListener('scroll', clearTapped, { passive: true });
  window.addEventListener('pagehide', clearTapped);
  if (phoneQuery.addEventListener) {
    phoneQuery.addEventListener('change', onRangeChange);
    tabletQuery.addEventListener('change', onRangeChange);
  } else if (phoneQuery.addListener) {
    phoneQuery.addListener(onRangeChange);
    tabletQuery.addListener(onRangeChange);
  }
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
